import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import {
  PropertyConstructionPeriod,
  PropertyCreationStep,
  PropertyDto,
  PropertyFinancialsDto,
} from '@workspace/data-types';
import { DtoChangedDetection } from '@workspace/ng-aura';
import { PropertyMissingInfoUtils } from '../../../utils/property-missing-info.utils';
import { EtxePropertySectionReminderComponent } from '../../property-section-reminder/property-section-reminder.component';
import { PropertyFinancialsDisplayComponent } from '../display/financials-display.component';
import { PropertyFinancialsFormComponent } from '../form/financials-form.component';

@Component({
  selector: 'etxe-property-financials-edit',
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    PropertyFinancialsDisplayComponent,
    PropertyFinancialsFormComponent,
    EtxePropertySectionReminderComponent,
  ],
  templateUrl: './financials-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyFinancialsEditComponent {
  PropertyConstructionPeriod = PropertyConstructionPeriod;
  property = input.required<PropertyDto>();
  editMode = input.required<boolean>();
  editable = input<boolean>(true);
  saving = input<boolean>(false);

  missingItems = computed(() =>
    PropertyMissingInfoUtils.getMissingItemsByStep(this.property(), PropertyCreationStep.FINANCIALS),
  );

  editToggled = output<void>();
  cancelToggled = output<void>();
  dtoChanged = output<DtoChangedDetection<PropertyFinancialsDto>>();
  submitted = output<void>();

  onEdit() {
    this.editToggled.emit();
  }

  onCancel() {
    this.cancelToggled.emit();
  }

  onDtoChanged(event: DtoChangedDetection<PropertyFinancialsDto>) {
    this.dtoChanged.emit(event);
  }

  onSubmit() {
    this.submitted.emit();
  }
}
